// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__K8fzp","spinner-border":"spinner_spinner-border__4cNJl"};